import React, { useContext } from 'react';

import { HeaderContext } from '../HeaderContext';

import { Button } from '@husslehq/ui-library';

import styles from './MobileLoginActions.module.scss';

export const MobileLoginActions: React.FC = () => {
  const { login, register } = useContext(HeaderContext);

  const trackMenu = async (category: string, action: string, label: string) => {
    const { track } = await import('../../../services/analytics');
    track({
      event: 'gym_spa',
      category: category,
      action: action,
      label: label,
    });
  };

  return (
    <div className={styles['login-actions']}>
      <a
        className={styles['login-actions--corporate-link']}
        href="https://benefits.hussle.com/login/finder"
        onClick={async () =>
          trackMenu('Registration', 'Click Business Login', 'User Redirects to Corporate Domain Finder')
        }
      >
        Employee benefit users login here &gt;
      </a>
      <div className={styles['login-actions--buttons']}>
        <Button
          size="large"
          level="primary"
          onClick={async () => {
            await trackMenu('OnClick', 'Mobile menu', 'Menu');
            login();
          }}
          className={styles['login-actions--button']}
        >
          Log In
        </Button>
        <Button
          size="large"
          level="outline"
          className={styles['login-actions--button']}
          onClick={async () => {
            await trackMenu('OnClick', 'Mobile menu', 'Menu');
            register();
          }}
        >
          Register
        </Button>
      </div>
    </div>
  );
};
